export default __webpack_public_path__ + "static/media/Attendance-EN.75b50770.png";